import { useNavigate } from "react-router";
import { OfferPonctual } from "../components/ReportComponent/OfferPonctual";
import { OfferWorkpackage } from "../components/ReportComponent/OfferWorkpackage";

export const SubscriptionPage = () => {
  const navigate = useNavigate();

  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="flex flex-row justify-end m-4">
        <button
          className="btn btn-neutral"
          onClick={() => {
            navigate("/report");
          }}
        >
          Retour au tableau de bord
        </button>
      </div>
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-md text-center mb-8 lg:mb-12">
          <h2 className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
            Réalisons vos projets web ensemble 🚀
          </h2>
          <p className="mb-5 font-light text-gray-500 sm:text-xl dark:text-gray-400">
          Nos sessions de préparation de projet ont aidé de nombreux clients à <span className=" text-sm lg:text-md font-bold">économiser des milliers d'euros</span> en clarifiant la conception de leurs projets. Nous serions ravis de vous accompagner et de voir votre projet réussir. 
          </p>
        </div>
        <div className="space-y-8 lg:grid lg:grid-cols-2 sm:gap-6 xl:gap-10 lg:space-y-0">
          <OfferPonctual />
          <OfferWorkpackage />
        </div>
      </div>
    </section>
  );
};
